import Chart from 'packages/Chart/Chart';
import {getColorToken} from '@ds/utils';

import type {ChartData, IntervalValue, PerformanceOverview} from '../../types';
import IntervalSelector from '../common/IntervalSelector/IntervalSelector';

type ScoreChartsProps = {
  overview?: PerformanceOverview;
  trend?: ChartData;
  interval: IntervalValue;
  onIntervalChange: (value: IntervalValue) => void;
};

const ScoreCharts: React.FC<ScoreChartsProps> = ({
  overview,
  trend,
  interval,
  onIntervalChange
}) => {
  const primaryColor = getColorToken('--color-orange');
  const primaryMutedColor = getColorToken('--color-orange-light-08');

  const radarConfig = overview
    ? {
        type: 'radar',
        data: {
          labels: overview.labels,
          datasets: [
            {
              data: overview.data,
              backgroundColor: primaryMutedColor,
              borderColor: primaryColor,
              borderWidth: 2,
              pointBackgroundColor: primaryColor
            }
          ]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          scales: {
            r: {min: 0, max: 100, ticks: {stepSize: 20, beginAtZero: true}}
          },
          plugins: {legend: {display: false}}
        }
      }
    : undefined;

  const lineConfig = trend
    ? {
        type: 'line',
        data: {
          labels: trend.labels,
          datasets: [
            {
              data: trend.dataset,
              borderColor: primaryColor,
              backgroundColor: primaryMutedColor,
              pointBackgroundColor: primaryColor
            }
          ]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          scales: {
            y: {
              max: Math.floor(Math.max(...trend.dataset) + 20),
              min: 0
            },
            x: {grid: {display: false}, min: 0}
          },
          plugins: {
            legend: {display: false},
            filler: {propagate: true}
          }
        }
      }
    : undefined;

  return (
    <>
      {radarConfig && (
        <section className="min-h-87.5 p-2.5">
          <Chart config={radarConfig} />
        </section>
      )}
      {lineConfig && (
        <section className="flex flex-col gap-4 px-4 py-4">
          <h2 className="text-subtitle-md text-gray-09">روند امتیاز عملکرد</h2>
          <IntervalSelector value={interval} onChange={onIntervalChange} />
          <div className="min-h-60 pr-2.5">
            <Chart config={lineConfig} />
          </div>
        </section>
      )}
    </>
  );
};

export default ScoreCharts;
